import React from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripSourceDetails({ label, options, source, onChange, isEditable }) {
    const intl = useIntl();

    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={intl.formatMessage({
                    id: `source.${_.kebabCase(source)}`,
                })}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
